export const Mission = () => {
    return (
        <section className="section-shell">
            <div className="section-block">
                <p className="section-body mb-8">
                    D&Dream Property Group was established in the year 2017,
                    October 1st and constantly expanding the team nationwide to
                    be the leading property agency in Malaysia. Through the
                    years of hard work and dedication, D&Dream Property Group
                    has obtained recognition from the market:
                </p>
                <img
                    className="w-full h-auto"
                    src="https://venti-fans.com/wp-content/uploads/2025/03/DD_WebsiteIcons-02_icF9qp5Yn-scaled.webp"
                    alt=""
                />
            </div>

            <div className="section-block">
                <h2 className="section-title">Vision</h2>
                <p className="section-body">
                To become Malaysia’s strongest real estate agency, built on the principles of equality, merit, and profit sharing, where everyone has the opportunity to grow, succeed, and lead.
                </p>
            </div>

            <div className="section-block">
                <h2 className="section-title">Mission</h2>
                <p className="section-body">
                To provide a comprehensive real estate platform that empowers the next generation of real estate professionals through abundant opportunities, continuous development, and 100% advance commission, enabling them to thrive and stand out in the industry.
                </p>
            </div>

            <div className="section-block">
                <h2 className="section-title">CORE VALUE</h2>
                <img
                    className="w-full h-auto max-h-[400px] object-contain mx-auto mb-6"
                    src="https://ik.imagekit.io/dnddecpho/dndream/D&D_WebsiteIcons-16_IKeS5pYym.png?updatedAt=1719760143986"
                    alt="ptp1comm"
                />
                <div className="section-body space-y-2 text-left sm:text-center">
                    <div>
                        <span className="primalbrown">A</span> - Agressive /
                        Execution / Result Oriented
                    </div>
                    <div>
                        <span className="primalbrown">L</span> - Leave No Man
                        Behind
                    </div>
                    <div>
                        <span className="primalbrown">L</span> - Loyalty
                    </div>
                    <div>
                        <span className="primalbrown">O</span> - Outstanding
                    </div>
                    <div>
                        <span className="primalbrown">U</span> - Unity
                    </div>
                    <div>
                        <span className="primalbrown">T</span> - Thankful /
                        Transparent / Trust
                    </div>
                </div>
            </div>

            <div className="media-band">
                <img
                    src="https://ik.imagekit.io/dnddecpho/dndream/D&D_WebsiteIcons-22_OxRTQgoyy.gif?updatedAt=1719761135594"
                    alt=""
                />
            </div>
        </section>
    );
};
